export { default } from "ember-truth-helpers/helpers/is-equal";
